module.exports = __webpack_public_path__ + "img/img_dog.a45ed5b6.svg";